import videojs from 'video.js'; // https://docs.videojs.com/player
import 'videojs-mux'; // https://docs.mux.com/guides/data/monitor-video-js
import GeckoStore from '../../../../services/GeckoStore';
import { $stateParams } from '../../../../router';
import Env from '../../../../services/Env';

export const keys = {
	prod       : 'vpgdm8ogb480bb4gddoh7sdhs',
	stage      : 'b43qan4brhhpltn0p47ofg7a3',
	local      : 'b43qan4brhhpltn0p47ofg7a3'
};

let player = null;

const extractIdFromUri = (uri) => {
	const found = uri.split('/').filter(s => s.includes('.ts'));
	if (found.length) {
		return Number(found[0].replace(/\.ts\?.+$/g, ''));
	}
	return null;
};

export const VideoService = {

	player: () => player,

	init: (playerRef) => {
		player = videojs(playerRef, {
            suppressNotSupportedError: true,
            controlBar: {
                pictureInPictureToggle: false,
                playToggle: true,
                progressControl: {
                    seekBar: false
                },
            },
            userActions: {
                doubleClick: false
            },
            html5: {
                vhs: {
                    overrideNative: true
                },
                nativeAudioTracks: false,
                nativeVideoTracks: false
            },
            plugins: {
                mux: VideoService.muxMonitorOpts()
            }
        });

	    return player;
	},

	destroy: () => {
		if (player) player.dispose();
		player = null;
		return player;
	},

	currentFragmentId: () => {
		const fragment = VideoService.currentFragment();
		return fragment ? extractIdFromUri(fragment.value.uri) : null;
	},

	currentFragment: () => {
		if (!player) return null;

		try {
			let tracks = player.textTracks();
			for (let i = 0; i < tracks.length; i++) {
				let track = tracks[i];
			  	if (track.label === 'segment-metadata') {
			  		return track.activeCues[0];
			  	}
			}
		} catch (err) {}

		return null;
	},

	lastFragmentId: () => {
		const fragment = VideoService.lastFragment();
		return fragment ? extractIdFromUri(fragment.uri) : null;
	},

	lastFragment: () => {
		if (!player) return null;

		try {
			const segments = player.tech().vhs.playlists.media().segments;
			if (segments.length) return segments[segments.length - 1];
		} catch (err) {}
		
		return null;
	},

	checkFragmentId: (fragmentId) => {
		const low  = VideoService.currentFragmentId() - 1;
		const high = VideoService.currentFragmentId() + 1;
		return fragmentId >= low && fragmentId <= high;
	},

	muxMonitorOpts: () => ({
        debug: false,
        data: {
            env_key: keys[Env()],
            player_init_time: Date.now(),
            viewer_user_id: $stateParams.contact_uuid,
            video_id: GeckoStore.redux.get('event').video_uuid,
            video_title: GeckoStore.redux.get('event').title
        }
    }),

};

export default VideoService;